export function toArrayOrNull(arr) {
  if (!Array.isArray(arr) || arr.length === 0) return null;
  return arr;
}

export function toDateString(date) {
  if (!date) return null;
  const d = new Date(date);
  if (isNaN(d.getTime())) return null;
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${yyyy}${mm}${dd}`;
}

export function downloadBlob(blob, fallbackFilename) {
  const contentType = blob.type || "application/octet-stream";
  const url = window.URL.createObjectURL(new Blob([blob], { type: contentType }));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fallbackFilename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}
